import { createContext, useContext } from "react";
import { IPolicyCreateContext } from "./types";

export const PolicyCreateContext = createContext<IPolicyCreateContext | null>(null);

export const usePolicyCreateContext = () => {
  const context = useContext(PolicyCreateContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
